import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Kasa, KasaClient} from "src/app/web-api-client";
import { WtStorageService } from "../../../wt-storage.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";

@Component({
  selector: 'app-kasa-open',
  templateUrl: './kasa-open.component.html',
  styleUrls: ['./kasa-open.component.scss']
})
export class KasaOpenComponent implements OnInit  {

  public isLoaded = true;
  public services: Kasa[];
  public onClose: Subject<void> = new Subject();

   Form: FormGroup;

  constructor(private fb: FormBuilder,public activeModal: NgbActiveModal,public wtStore:WtStorageService,public client:KasaClient ) { }

  ngOnInit(): void {
    this.initializeForm();
  }

  initializeForm() {
    this.Form = this.fb.group({
      startAmount: ['', Validators.required],
      createdOn: [new Date(), Validators.required],
      isActive: [true, Validators.required]
    });
  }

  onSubmit() {
    if (this.Form.valid) {

      let service =new Kasa();

      service.idKasa = 0;
      service.startAmount = this.Form.value.startAmount;
      service.createdOn = new Date();
      service.amount = service.startAmount;
      service.operatorId = this.wtStore.getuser().id;

      this.client.create(service).subscribe((user)=>{

        this.onClose.next();
        this.activeModal.close();
      });
    }
  }

}
